import { useRef, useSyncExternalStore } from 'react';
import { Button } from '@/components/ui/button';
import { openSupportDetails, supportStore } from '@/lib/error-support';

// Lives inside modal content so focus trapping and outside-pointer protection remain intact.
export function SupportShortcut() {
  const incidents = useSyncExternalStore(supportStore.subscribe, supportStore.snapshot);
  const mountedAt = useRef(Date.now());
  const incident = incidents[0];
  if (!incident || Date.parse(incident.occurredAt) < mountedAt.current) return null;
  return (
    <aside
      className="mt-2 min-w-0 space-y-2 rounded-lg border p-3 text-sm"
      aria-label="Orientação do erro"
    >
      <p className="break-words">
        Código: <strong>{incident.support.code}</strong>
      </p>
      {incident.support.fields.map((field, index) => (
        <p key={index} className="text-xs">
          {field.label}: {field.message} ({field.code})
        </p>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={openSupportDetails}>
        Ver solução e copiar detalhes
      </Button>
    </aside>
  );
}
